import classNames from 'classnames';
import type { ReactNode } from 'react';
import React, { memo } from 'react';

import { Badge } from '@sravni/react-design-system/lib/Badge';
import { Heading } from '@sravni/react-design-system/lib/Typography';

import styles from './FullDealEntryPointBanner.module.scss';
import { FullDealEntryPointBannerTexts } from './FullDealEntryPointBanner.texts';

interface Props {
  hasOffer: boolean;

  // пока оставил мало ли понадобится
  // eslint-disable-next-line react/no-unused-prop-types
  heading?: string;
  // eslint-disable-next-line react/no-unused-prop-types
  isLanding?: boolean;
  mobileBanner: ReactNode;
  isMobile?: boolean;
}

export const FullDealEntryPointBanner = memo(({ hasOffer, mobileBanner, isLanding, heading }: Props) => (
  <div className={styles.container}>
    <div className={classNames(styles.mobileBanner, 'desktop:hidden')}>{mobileBanner}</div>
    <div className={styles.header}>
      {/* todo: сделали дивом по указанию СЕО https://sravni-corp.slack.com/archives/C08LAGUJQRZ/p1755239085670589 */}
      <Heading level={isLanding ? 1 : 2} size={{ desktop: 50, mobile: 25 }} className={styles.title} as="div">
        {isLanding ? heading || FullDealEntryPointBannerTexts.title : FullDealEntryPointBannerTexts.title}
      </Heading>
      <Badge
        variant="primary"
        color="light"
        className={styles.badge}
        text={hasOffer ? FullDealEntryPointBannerTexts.badgeTitle : FullDealEntryPointBannerTexts.badgeTitleWithTime}
      />
    </div>
  </div>
));

FullDealEntryPointBanner.displayName = 'FullDealEntryPointBanner';
